export class CustomerReferral {
  id: number;
  customerId: number;
  code: string;
  status: string;
}
